import React, { useState } from 'react';
import { FaBootstrap, FaCss3Alt, FaHtml5, FaNodeJs, FaReact, FaGitAlt, FaAngular } from "react-icons/fa";
import { SiExpress, SiFirebase, SiFlutter, SiJavascript, SiMongodb, SiTailwindcss, SiTypescript } from "react-icons/si";
import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';
import './Skills.css';
import useTitle from '../../Hooks/useTitle';

const Skills = () => {
    useTitle("Skills");
    const [countOn, setCountOn] = useState(false);

    const technicalSkills = [
        {
            id: 1,
            name: 'HTML',
            icon: <FaHtml5></FaHtml5>,
            iconColor: 'text-yellow-600',
            percentage: '85',
        },
        {
            id: 2,
            name: 'CSS',
            icon: <FaCss3Alt />,
            iconColor: 'text-sky-600',
            percentage: "80",
        },
        {
            id: 3,
            name: 'Bootstrap',
            icon: <FaBootstrap />,
            iconColor: 'text-purple-600',
        },
        {
            id: 4,
            name: 'Tailwind CSS',
            icon: <SiTailwindcss />,
            iconColor: 'text-sky-600',
        },
        {
            id: 5,
            name: 'JavaScript',
            icon: <SiJavascript />,
            iconColor: 'text-yellow-400',
        },
        {
            id: 6,
            name: 'TypeScript',
            icon: <SiTypescript />,
            iconColor: 'text-blue-500',
        },
        {
            id: 7,
            name: 'React.js',
            icon: <FaReact />,
            iconColor: 'text-teal-400',
        },
        {
            id: 8,
            name: 'Angular',
            icon: <FaAngular />,
            iconColor: 'text-red-600',
        },
        {
            id: 9,
            name: 'Git',
            icon: <FaGitAlt />,
            iconColor: 'text-slate-300',
        },
        {
            id: 10,
            name: 'Node.js',
            icon: <FaNodeJs />,
            iconColor: 'text-green-600',
        },
        {
            id: 11,
            name: 'Express.js',
            icon: <SiExpress />,
            iconColor: 'text-white',
        },
        {
            id: 12,
            name: 'Firebase',
            icon: <SiFirebase></SiFirebase>,
            iconColor: 'text-yellow-400',
        },
        {
            id: 13,
            name: 'MongoDb',
            icon: <SiMongodb />,
            iconColor: 'text-green-400',
        },
        {
            id: 14,
            name: 'Flutter (Android & IOS)',
            icon: <SiFlutter />,
            iconColor: 'text-green-400',
        },
    ]
    return (
        <div className='pb-20 pt-10 px-5 md:px-20 lg:px-32 max-w-[1400px] m-auto'>
            <h1 className='text-4xl font-bold text-center mb-10 tracking-widest'>My <span className='text-teal-300'>Skills</span></h1>

            <div className='flex flex-col md:flex-row lg:flex-row justify-between'>
                {/* Technical Skills */}
                <div className='w-full md:w-1/2 lg:w-1/2'>
                    <h1 className='text-center font-bold text-xl mb-8'>Technical Skills</h1>

                    <div className='grid grid-cols-2 gap-1'>
                        {
                            technicalSkills.map(technical => <div key={technical.id} className='mb-4 '>

                                <h1 className='tech-skill flex items-center gap-2 font-bold p-2'>
                                    <span className={`${technical.iconColor} text-xl`}>{technical.icon}</span>{technical.name}
                                </h1>
                            </div>)
                        }
                    </div>
                </div>

                {/* Professional Skills */}
                <div className='mt-10 md:mt-0 lg:mt-0'>
                    <h1 className='text-center font-bold text-xl mb-14'>Professional Skills</h1>
                    <ScrollTrigger onEnter={() => setCountOn(true)} onExit={() => setCountOn(false)} className='grid grid-cols-2 gap-10'>
                        <div data-aos="flip-left" data-aos-easing="ease-out-cubic" className='flex flex-col justify-center items-center'>
                            <div className="radial-progress text-teal-300" style={{ "--value": 90 }} role="progressbar">
                                <div className='flex font-bold'>
                                    {
                                        countOn &&
                                        <CountUp start={0} end={90} duration={2} delay={0}></CountUp>
                                    }%
                                </div>
                            </div>
                            <h1 className='text-xs font-bold'>Creativity</h1>
                        </div>

                        <div data-aos="flip-left" data-aos-easing="ease-out-cubic" className='flex flex-col justify-center items-center'>
                            <div className="radial-progress text-teal-300" style={{ "--value": 80 }} role="progressbar">
                                <div className='flex font-bold'>
                                    {
                                        countOn &&
                                        <CountUp start={0} end={80} duration={2} delay={0}></CountUp>
                                    }%
                                </div>
                            </div>
                            <h1 className='text-xs font-bold'>Communication</h1>
                        </div>

                        <div data-aos="flip-left" data-aos-easing="ease-out-cubic" className='flex flex-col justify-center items-center'>
                            <div className="radial-progress text-teal-300" style={{ "--value": 85 }} role="progressbar">
                                <div className='flex font-bold'>
                                    {
                                        countOn &&
                                        <CountUp start={0} end={85} duration={2} delay={0}></CountUp>
                                    }%
                                </div>
                            </div>
                            <h1 className='text-xs font-bold'>Team Work</h1>
                        </div>

                        <div data-aos="flip-left" data-aos-easing="ease-out-cubic" className='flex flex-col justify-center items-center'>
                            <div className="radial-progress text-teal-300" style={{ "--value": 70 }} role="progressbar">
                                <div className='flex font-bold'>
                                    {
                                        countOn &&
                                        <CountUp start={0} end={70} duration={2} delay={0}></CountUp>
                                    }%
                                </div>
                            </div>
                            <h1 className='text-xs font-bold'>Problem Solving</h1>
                        </div>
                    </ScrollTrigger>
                </div>
            </div>
        </div>
    );
};

export default Skills;